import { isPropertyOfSpecificType } from '@core/core/helpers'
import type {
  MultipartUploadedFile,
  MultipartUploadedFileSetupType,
  UploadedFileEntityType,
} from '@core/core/types'
import { AxiosError } from 'axios'
import { logIfNotTest } from 'common/helpers'

export const isMultipartSetupOfSpecificType = <T extends MultipartUploadedFileSetupType>(
  uploadedFile: MultipartUploadedFile | undefined,
  setupContent: MultipartUploadedFileSetupType | undefined,
  type: UploadedFileEntityType,
): setupContent is T =>
  isPropertyOfSpecificType<
    MultipartUploadedFile,
    MultipartUploadedFileSetupType,
    UploadedFileEntityType,
    T
  >(uploadedFile, setupContent, type)

export const apiWrapper = async <T>(description: string, action: () => Promise<T>) => {
  const retryTotalNumber = 10
  let retryNumber = retryTotalNumber
  const retryDelay = 5000
  const retriableErrorCodes = ['ERR_NETWORK']
  const retriableResponseStatuses = [503]
  const delay = () => {
    return new Promise(resolve => setTimeout(resolve, retryDelay))
  }

  const shouldRetry = (error: AxiosError) =>
    retriableErrorCodes.includes(error.code ?? '') ||
    retriableResponseStatuses.includes(error.response?.status ?? 200)

  while (retryNumber-- > 0) {
    try {
      return await action()
    } catch (error) {
      logIfNotTest(description, error)
      if (!(error instanceof AxiosError) || !shouldRetry(error)) {
        throw error
      }

      logIfNotTest(description, `Попытка ${retryNumber} из ${retryTotalNumber}`)
      await delay()
    }
  }
}
